import ProjectSettings from "../components/setting/projectSettings/ProjectSettings"
const ProjectSettingsPage =() =>{
     
    return(
       <ProjectSettings/>
    )
}

export default ProjectSettingsPage;